import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';

import { AddressPropType } from '../../constants/types/common';

/**
 * A helper component for outputting and Address types from the GraphQL API. It's
 * purpose is to generate decent looking addresses even when some of the elements
 * that make up an address are missing.
 *
 * Example output all address elements:
 * Street Address
 * City, Region
 * Postal Code, Country
 *
 * Example output missing elements (city):
 * Street Address
 * Region
 * Postal Code, Country
 *
 * Example out missing elements (city and region):
 * Street Address
 * Postal Code, Country
 *
 * @class Address
 */
class Address extends PureComponent {
  static propTypes = {
    address: AddressPropType
  };

  static defaultProps = {
    address: PropTypes.shape({
      address: undefined,
      city: undefined,
      country: undefined,
      postalCode: undefined,
      region: undefined
    })
  };

  render() {
    const { address } = this.props;

    const { address: streetAddress, city, country, postalCode, region } = address;

    // Configure format for output
    const lineConfiguration = [
      [streetAddress], // Line 1
      [city, region], // Line 2
      [postalCode, country] // Line 3
    ];

    // Remove any empty (null, undefined, '') address elements and/or empty lines
    const filteredLines = lineConfiguration.reduce((lines, line) => {
      const filteredLine = line.filter(element => typeof element === 'string' && element.trim().length > 0);

      if (filteredLine.length > 0) {
        lines.push(filteredLine);
      }

      return lines;
    }, []);

    // Output as JSX (this can be nested as a child inside any element you choose)
    return (
      <Fragment>
        {filteredLines.map((line, index) => {
          const lineJoined = line.join(', ');
          const lineBreak = index < filteredLines.length - 1;

          return (
            <Fragment key={lineJoined}>
              {lineJoined}
              {lineBreak && <br />}
            </Fragment>
          );
        })}
      </Fragment>
    );
  }
}
export default Address;
